import { getProjectUsersAdvancedFilters } from "../api/projectDetailsHttpClient";

export const useProjectUsersTable = () => {
  return { fetchGridData: getProjectUsersAdvancedFilters };
};
